

      <div *ngIf="!winaijaStyle" class="lottery-time">{{message}}</div>
      <div *ngIf="winaijaStyle" class="lottery-time-winaija" [innerHTML]="message"></div>
  